import { useEffect, useState } from 'react'
import { getAppFlag } from '../../lib/appSettings'

// §10 Self-contained maintenance banner. Reads the maintenance_mode flag once and
// renders a top-of-app strip when it's on. Returns null otherwise, so dropping
// <MaintenanceBanner /> into the app is a no-op behaviorally when maintenance is off.
export default function MaintenanceBanner() {
  const [on, setOn] = useState(false)
  const [message, setMessage] = useState('')

  useEffect(() => {
    let active = true
    Promise.all([
      getAppFlag<boolean>('maintenance_mode'),
      getAppFlag<string>('maintenance_message'),
    ]).then(([mode, msg]) => {
      if (!active) return
      setOn(mode === true)
      setMessage(typeof msg === 'string' ? msg : '')
    })
    return () => { active = false }
  }, [])

  if (!on) return null
  return (
    <div className="bg-amber-500 text-white text-xs text-center px-4 py-2 font-medium">
      {message || 'Social Brew is undergoing maintenance — some features may be temporarily unavailable.'}
    </div>
  )
}
